import React from 'react';
import {
    IDrawerContent,
    IDrawerContentHandler
} from '../../../drawer/drawer.service.interface';
import {CasinofiedApplicationBase} from './casinofied-application-base';
import {AreaType, IDivHostedAppInitParameters} from '@sparkware/uc-sdk-core';
import {OnErrorComponent} from '../../../../components/on-error/on-error.component';
import {STANDARD_TOPIC_HEADER} from '../../message-broker/message-broker.consts';
import {
    CHANNEL_ELEMENTS,
    CHANNEL_SOURCE,
    DISPLAY_MESSAGE_IDS
} from '../../../../../common/const/casinofied-analytics-consts';


export class InsideDrawerApplication extends CasinofiedApplicationBase implements IDrawerContent {
    /**
     * IDrawerContent.id
     * Used by drawer to uniquely identify the content
     */
    get id() {
        return this._openAppData.launchInfo.containerID;
    }

    /**
     * IDrawerContent.id
     * Used by drawer to decide the z-index
     */
    get minOverlayZIndex(): number | null {
        return null;
    }

    /**
     * IDrawerContent.render
     * Called by drawer to render the content
     */
    render(): React.ReactNode {
        if(this._appInitFailed) {
            return (<OnErrorComponent onRetryButtonClick={() => this._retryOpen()}
                                      onCloseButtonClick={() => this.dispose()} />);
        }
        return (
            // We just render an empty React fragment.
            // The Drawer will create a div with an id equal to _launchInfo.containerID returned by IDrawerContent.id getter
            // and the app will render itself inside that div.
            <></>
        );
    }

    private _retryOpen() {
        this.dispose();
        this.services.messageBroker.channels.navigation.topics.openApp.publish(STANDARD_TOPIC_HEADER, {
            ...this._openAppData,
            launchInfo: {
                ...this._openAppData.launchInfo,
                businessCorrelationID: this.services.tools.getGuid(),
                channel: {
                    source: CHANNEL_SOURCE.casinoClient,
                    area: AreaType.Message,
                    element: CHANNEL_ELEMENTS.retryButton
                }
            }
        });
    }

    /**
     * IDrawerContent.onClose
     * Called by drawer when is closed (click on the overlay, user login/logout etc.
     */
    onClose(): void {
        if (this._shouldMinimizeOnDrawerClose()) {
            if (!this.isMinimized) {
                this._setIsMinimized(true);
                this._publishMinimizeApp();
            }
        } else {
            this._publishAppClosed({
                source: CHANNEL_SOURCE.casinoClient,
                area: AreaType.Overlay,
                element: ""
            });
        }
    }

    protected _setAppInitFailed() {
        super._setAppInitFailed();
        this.services.casinofiedAnalytics.messageDisplay({
            businessCorrelationID: this._openAppData.launchInfo?.businessCorrelationID,
            displayMessageID: DISPLAY_MESSAGE_IDS.retryCloseDrawerMessage
        });
    }

    protected _shouldMinimizeOnDrawerClose(): boolean {
        return false;
    }

    dispose() {
        super.dispose();
        this._drawerContentHandler?.remove();
    }


    private _drawerContentHandler: IDrawerContentHandler;
    protected _showApp(initParams: IDivHostedAppInitParameters) {
        this._drawerContentHandler = this.services.drawer.right.push(this);
        super._showApp(initParams);
    }

    maximize() {
        super.maximize();
        this._drawerContentHandler = this.services.drawer.right.push(this);
    }
}
